// import the vue-router
import Vue from 'vue'
import VueRouter from 'vue-router'
import { get } from 'lodash'

// import application routes
import { routes as app } from '@/app'

// run before each route change
import beforeEach from './beforeEach'

// make vue-router available on Vue
Vue.use(VueRouter)

// spread app routes
const routes = [...app]

// debugs para rotas
if (get(process.env, 'NODE_ENV') === 'development') {
  console.log('routes', routes)
}

// create a new router instance.
const router = new VueRouter({
  routes,
  linkActiveClass: 'active',
  mode: 'history'
})

// setup a before each for routes.
router.beforeEach(beforeEach)

// return the router on the default export.
export default router



// WEBPACK FOOTER //
// ./src/router/index.js